module.exports = __webpack_public_path__ + "static/img/mainMockupRight.a29d2dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/mainMockupRight.png
// module id = obYc
// module chunks = 0